import { requests } from "../../API/Api";
import { AgentDetailSavePayload } from "./agentDetail.model";
import { ICreateDownlineRequest } from "./components/createDownlineModal/createDownline.models";
import { IGetAllAgentsPayload } from "./agents.model";
import {
    IDownloadDownLineHierarchyRequest,
    IUpdateAgentDownLinesStatusRequest,
} from "./components/editAgent/components/mainDetails/components/rightSection/components/contractPanel/components/hierarchy/hierarchy.models";

const GetAllAgentsDetails = {
    post: (payload: IGetAllAgentsPayload) =>
        requests.post("/api/developmentportal/get-all-agents-details", payload),
};

const GetAgentDetails = {
    get: (userId: number) =>
        requests.get(`/api/developmentportal/get-agent-details?userId=${userId}`),
};

const GetAllStates = {
    get: () => requests.get("/api/developmentportal/get-all-states"),
};

const UpdateAgentDetails = {
    post: (payload: AgentDetailSavePayload) =>
        requests.post("/api/developmentportal/update-agent-details", payload),
};

const GetAgenciesList = {
    get: () => requests.get("/api/developmentportal/get-agencies-list"),
};

const GetAgentsList = {
    get: () => requests.get("/api/developmentportal/get-agents-list"),
};

const GetAllUserTypes = {
    get: () => requests.get("/api/developmentportal/get-all-user-types"),
};

const GetAvailableProductsAndCommissions = {
    get: (parentUserId: number) =>
        requests.get(
            `/api/developmentportal/get-available-products-and-commissions?userId=${parentUserId}`
        ),
};

const UpdateAgentDownLinesStatus = {
    post: (payload: IUpdateAgentDownLinesStatusRequest) =>
        requests.post("/api/developmentportal/update-agent-downlines-status", payload),
};

const DownloadDownLineHierarchy = {
    post: (payload: IDownloadDownLineHierarchyRequest) =>
        requests.postBlob("/api/developmentportal/download-agent-downline-hierarchy", payload),
};

const GetAvailableUserTypes = {
    get: (userId: number) =>
        requests.get(`/api/developmentportal/get-available-user-types?userId=${userId}`),
};

const CreateDownline = {
    post: (payload: ICreateDownlineRequest) =>
        requests.postSilent("/api/developmentportal/create-downline", payload),
};

const ResendInviteToAgent = {
    post: (email: string) =>
        requests.post(`/api/developmentportal/resend-invite-to-agent?email=${email}`, {}),
};

const agentsApi = {
    GetAllAgentsDetails,
    GetAgentDetails,
    GetAllStates,
    UpdateAgentDetails,
    GetAgenciesList,
    GetAgentsList,
    GetAllUserTypes,
    GetAvailableProductsAndCommissions,
    UpdateAgentDownLinesStatus,
    DownloadDownLineHierarchy,
    GetAvailableUserTypes,
    CreateDownline,
    ResendInviteToAgent,
};

export default agentsApi;
